<div class="version-number" *ngIf="pageStatus == STATUS_DONE">
        <div class="version">
            <form [formGroup]="form">
                <fieldset class="version_fieldset">
                    <label class="version-label">Artwork Number </label>
                    <div>
                      <input type="number" formControlName="version" (change)="onVersionChange()"/><span>.</span>
                      <input type="number" formControlName="subversion" (change)="onSubVersionChange()"/>
                    </div>
                </fieldset>
            </form>
        </div>
</div>
